import * as token from "@universityofmaryland/web-token-library";
import { close_large } from "@universityofmaryland/web-icons-library/controls";
import "@universityofmaryland/web-builder-library";
import "@universityofmaryland/web-styles-library/element";
import "@universityofmaryland/web-styles-library/layout";
import "@universityofmaryland/web-styles-library/animation";
import "@universityofmaryland/web-styles-library/typography";
import "@universityofmaryland/web-utilities-library/media";
import "@universityofmaryland/web-utilities-library/dom";
import "@universityofmaryland/web-icons-library/communication";
import "@universityofmaryland/web-icons-library/files";
import "@universityofmaryland/web-icons-library/brand";
import "@universityofmaryland/web-icons-library/arrows";
import "@universityofmaryland/web-utilities-library/performance";
import "../../../atomic/animations/brand/chevron-scroll.js";
import "../../../atomic/animations/brand/card-stack.js";
import "@universityofmaryland/web-styles-library";
import "@universityofmaryland/web-utilities-library/accessibility";
import "@universityofmaryland/web-icons-library/location";
import "@universityofmaryland/web-icons-library/calendar";
import "@universityofmaryland/web-utilities-library/theme";
import "../../../atomic/layout/block/stacked.js";
import { createModal } from "../../../atomic/layout/overlay/modal.js";
import "../../../atomic/layout/person/columns.js";
import "@universityofmaryland/web-icons-library/social";
import "../../../atomic/text-lockup/date.js";
import "../../../atomic/text-lockup/small.js";
const ELEMENT_CLOSE_BUTTON = "carousel-fixed-screen-button";
const STYLES_FIXED_FULL_SCREEN = `


  .${ELEMENT_CLOSE_BUTTON} {
    position: absolute;
    top: 10px;
    right: 10px;
  }

  @media (${token.media.queries.tablet.min}) {
    .${ELEMENT_CLOSE_BUTTON} {
      top: calc(10vh - 22px);
      right: calc(10vw - 22px);
    }
  }

  .${ELEMENT_CLOSE_BUTTON} > svg {
    fill: ${token.color.white};
    width: 20px;
    height: 20px;
  }
`;
const createCompositeCarouselFullScreen = ({ content, callback }) => {
  const modal = createModal({ content, callback });
  const closeButton = document.createElement("button");
  let styles = STYLES_FIXED_FULL_SCREEN;
  styles += modal.styles;
  closeButton.setAttribute("type", "button");
  closeButton.setAttribute("aria-label", "Close");
  closeButton.classList.add(ELEMENT_CLOSE_BUTTON);
  closeButton.innerHTML = close_large;
  closeButton.addEventListener("click", modal.events.hide);
  modal.element.appendChild(closeButton);
  return {
    element: modal.element,
    styles,
    events: {
      show: modal.events.show,
      hide: modal.events.hide
    }
  };
};
export {
  createCompositeCarouselFullScreen
};
//# sourceMappingURL=full-screen.js.map
